import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import {
  TRANSFER_STATUSES,
  type TransferFilters,
  type TransferStatus,
} from '@/features/inventory-transfers/api'
import { TransfersScreen } from '@/features/inventory-transfers/transfers-screen'
import { hasGrant } from '@/lib/me'

const text = (value: unknown) => (typeof value === 'string' && value ? value : undefined)
const positive = (value: unknown) => {
  const number =
    typeof value === 'number' ? value : typeof value === 'string' ? Number(value) : Number.NaN
  return Number.isInteger(number) && number > 0 ? number : undefined
}

export const Route = createFileRoute('/_authenticated/inventory/transfers/')({
  validateSearch: (search: Record<string, unknown>): TransferFilters => ({
    status: TRANSFER_STATUSES.find((status: TransferStatus) => status === search.status),
    from: text(search.from),
    to: text(search.to),
    q: text(search.q),
    page: positive(search.page),
    perPage: positive(search.perPage),
  }),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'stock_transfer.view')) throw redirect({ to: '/' })
  },
  component: InventoryTransfersRoute,
})

function InventoryTransfersRoute() {
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <TransfersScreen
      params={Route.useSearch()}
      onParamsChange={(next) => void navigate({ search: next })}
    />
  )
}
